module.exports = __webpack_public_path__ + "media/assets/images/tour/5_Tour_2-9e62aa837d58b127fb66176bffc83302.png";